export default __webpack_public_path__ + "static/media/all-free@2x.a29187a2.jpg";